import {
	OtaFirmwareUpdate,
	OtaFirmwareUpdateDetail,
	OtaAudioUpdate,
	OtaAudioUpdateDetail,
	OTAMainUpdate,
	OTAMainUpdateDetail,
} from '../../pages';
import { FileUpdateLayout, Layout } from '../../components';

export default [
	{
		/* OTA基本设定 - 主要更新 */
		path: '/OTAMainUpdate',
		title: 'ota-main-update',
		permission: 'authSystem',
		requireAuth: false,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OTAMainUpdate />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* OTA基本设定 - 主要更新 - 編輯 */
		path: '/OTAMainUpdate/edit/:otaGuid',
		title: 'ota-main-update-edit',
		permission: 'authSystem',
		requireAuth: false,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OTAMainUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* OTA基本设定 - 主要更新 - 新增 */
		path: '/OTAMainUpdate/create',
		title: 'ota-main-update-create',
		permission: 'authSystem',
		requireAuth: false,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OTAMainUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* Ota管理 - Firmware */
		path: '/otafirmwareupdate',
		title: 'ota-firmware-update',
		permission: 'authOta',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OtaFirmwareUpdate />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* Ota管理 - Firmware - 新增 */
		path: '/otafirmwareupdate/create',
		title: 'ota-firmware-update-create',
		permission: 'authOta',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OtaFirmwareUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* Ota管理 - Firmware - 編輯 */
		path: '/otafirmwareupdate/edit',
		title: 'ota-firmware-update-edit',
		permission: 'authOta',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OtaFirmwareUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* Ota管理 - Audio */
		path: '/otaaudioupdate',
		title: 'ota-audio-update',
		permission: 'authOta',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OtaAudioUpdate />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* Ota管理 - Audio - 新增 */
		path: '/otaaudioupdate/create',
		title: 'ota-audio-update-create',
		permission: 'authOta',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OtaAudioUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* Ota管理 - Audio - 編輯 */
		path: '/otaaudioupdate/edit',
		title: 'ota-audio-update-edit',
		permission: 'authOta',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<OtaAudioUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
];
